






























































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import VJsonschemaForm from "@pan-gms/vuetify-jsonschema-form";
import NavigationButtons from "./NavigationButtons.vue";
import { ApplicationBudget, Feedback } from "@/entities";
import { AppConstants as _app } from "@/shared/app.constants";
import { Locales } from "@/i18n/locales";
import "vuetify/dist/vuetify.min.css";
import "@/styles/iucn/financial.css";
import "@/styles/iucn/table-budget.css";
import "@/styles/iucn/budget.css";
import "@pan-gms/vuetify-jsonschema-form/dist/main.css";
import ImportButton from '@/components/common/Buttons/ImportButtons.vue';

const namespace: string = "conceptNote";

@Component({
  components: {
    NavigationButtons,
    VJsonschemaForm,
    ImportButton
  }
})
export default class ApplicationBudgetComponent extends Vue {
  // @Action("getApplicationBudget", { namespace }) getBudget: any;
  @Action("saveApplicationBudget", { namespace }) saveApplicationBudget: any;
  @Action("createFeedbackHeader", { namespace: "feedback" }) createFeedbackHeader: any;
  @Action("getFeedbacks", { namespace: "feedback" }) getFeedbacks: any;
  @Action("resolve", { namespace: "feedback" }) resolveFeedback: any;
  @Action("reopen", { namespace: "feedback" }) reopenFeedback: any;
  @Action("importBudgetFile", { namespace }) importFile: any;
  @Getter("applicationBudget", { namespace }) budget: ApplicationBudget;
  @Getter("rootTemplate", { namespace }) schema: any;
  @Getter("isRAGTemplate", { namespace }) isRAG: boolean;
  @Getter("currency", { namespace }) currency: string;
  @Getter("_appUser", { namespace: "RootApp" }) _username!: string;
  @Getter("_appUserId", { namespace: "RootApp" }) _userid!: number
  @State("feedback") feedback!: Feedback;
  @Prop() appData!: any;
  @Prop() readOnly: boolean;
  @Prop() appId!: number;
  @Prop() budgetLimit: number;
  @Prop() grantType: any;
  @Prop() isDirty!: boolean;
  @Prop() budgetInstruction!: any;
  @Prop() indirectCost!: any;
  @Prop() isFixedindirectCost!: any;
  @Prop() budgetFootnote!: string;

  /** declare variables */
  formValid: boolean = false;
  schemaformKey: number = 0;
  data: any = {};
  isSelecting: boolean = false;
  budgetValidations: any = [];
  menuButtons = _app.budgetMenuButtons;
  defaultLocale: string = localStorage.getItem("language") || Locales.EN;

  mounted() {
  }

  get options(): any {
    return {
      disableAll: this.readOnly && this.readOnly === true ? true : false,
      currency: this.currency,
      transactionId: this.appId,
      //@ts-ignore
      rights: this.$can("manage", "feedback") ? _app.actions.manage : _app.actions.read,
      importAction: this.importFile,
      user: this._userid,
      entity: _app.entities.conceptNote,
      feedbacks: this.feedback.feedbackHeaders,
      PopulateExcel: this.$services.budget.exportToExcel,
      downloadAction: this.$services.budget.generateTemplate,
      indirectCost: this.indirectCost,
      formatString: this.$services.format.personalizeString,
      actions: {
        createHeader: this.createFeedbackHeader,
        list: this.getFeedbacks,
        resolveFeedback: this.resolveFeedback,
        reopenFeedback: this.reopenFeedback,
        updateFeedback: this.$services.comment.Update
      },
      fileSizeLimit: this.appSettings.MaxFileSizeLimit,
      summaryAction: this.calculateFundingPercentage,
      isFixedindirectCost: this.isFixedindirectCost,
      locale: this.defaultLocale
    };
  }

  /** get schema properties to populate the left panel*/
  get subSchema(): any {
    if (this.budget.templates) {
      //percOfCofinance is deleted from sumamry if 
      this.budget.templates["isRAG"] = this.budget.templates.budgetType === "BEST_CN" ? false : this.isRAG;
      return this.budget.templates;
    } else {
      return {};
    }
  }

  get showImportButton(): any {
    return (this.subSchema.hasOwnProperty("budgetType") && this.subSchema["budgetType"] === "BEST_CN") ? false : true;
  }

  onButtonClick() {
    this.isSelecting = true
    window.addEventListener('focus', () => {
      this.isSelecting = false
    }, { once: true })

    //@ts-ignore
    this.$refs.uploader.click();
  }

  onAddFiles(e: any) {
    let files = e;
    if (files) {
      const { name, type, size } = files;
      // TODO: Show snakbar status
      if (size < (this.appSettings.MaxFileSizeLimit || 10485760)) {
        this.importFile({ "file": files, "transactionId": this.appId, "schema": this.subSchema, context: "ConceptNote" })
          .then((resp) => {
            if (resp.Result === 'OK') {
              this.appData.applicationBudget = resp.Record;
              this.budgetValidations = resp.Validation;
              this.$emit('totalChanged', resp.Record.summary);
              this.$emit('input', true);
              this.schemaformKey += 1;
            }
          })
      }
    }
  }

  exportBudget(e: any) {
    this.$services.budget.exportToExcel(this.appId, `Budget_ConceptNote_CN-${this.appId}`, "ConceptNote");
  }

  downloadBudget(e: any) {
    this.$services.budget.generateTemplate(this.appId, `Budget_ConceptNote_CN-${this.appId}`, "ConceptNote");
  }

  get footNotes() {
    let notes = [], tmp, arr = [];
    if (this.subSchema.hasOwnProperty("budgetType") && this.subSchema["budgetType"] === "TSG") {
      _app.budgetFootnoteKeys.forEach(item => {
        if (item === 'coFinDesc') {
          tmp = this.$services.format.formatCurrency(0.8 * this.budgetLimit, this.currency, this.defaultLocale);
          arr.push(tmp);
          tmp = this.$services.format.formatCurrency(0.9 * this.budgetLimit, this.currency, this.defaultLocale);
          arr.push(tmp);
          tmp = this.$services.format.personalizeString(`${this.$t(item)}`, arr);
        }
        notes.push(tmp);
      });
    }
    return notes;
  }

  /** error event */
  showError(err) {
    window.alert(err);
  }

  /** change event */
  showChange(e) {
    this.$emit('input', true);
    // console.log('"change" event', e)
  }

  /** input event */
  showInput(e) {
    this.$emit('input', true);
    // console.log('"input" event', e)
  }

  /** save the comment */
  saveComment(comment: any, obj: any) {
    comment.user = this._username;
    this.$services.comment.Save(comment, obj)
      .then((resp: any) => {
        if (resp.Result == "OK") {
          resp.Record["comment"] = resp.Record["Comment"];
          obj.comments.unshift(resp.Record);
        }
      });
  }

  /** resolve the comment */
  resolveComment(obj: any) {
    this.$services.comment.Resolve(obj);
  }

  // Calculate requested fund from percentage of co-finance
  calculateFundingPercentage(data, summary) {
    if (this.subSchema.hasOwnProperty("budgetType") && this.subSchema["budgetType"] === "BEST_CN") {
        summary.percOfReqFund = {
          Total: {
            value: 100 - summary.percOfCofinance.Total.value
          }
        };
    }
  }

  /** watch state and update the variable */
  @Watch("budget.templates")
  onTemplateChange(val: any) {
    this.schemaformKey += 1;
  }

  @Watch("appData")
  onDataChanged(value: any, oldValue: any) {
    this.schemaformKey += 1;
  }
}
